// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { SuggestionType } from '../../types/suggestion';
import { Link } from '../../../router';
import messages from './messages';
import styles from './styles';

type Props = {
  suggestion: SuggestionType,
  suggestionsPrefix: string,
};

function SuggestionItem({ suggestion, suggestionsPrefix }: Props) {
  return (
    <li>
      <Link route={suggestion.url}>
        <a className="suggestion-link">
          <span className="keyword">
            {suggestionsPrefix} <b>{suggestion.name}</b>
          </span>
          <span className="results">
            {suggestion.total} <FormattedMessage {...messages.suggestionResults} />
          </span>
        </a>
      </Link>
      <style jsx>{styles}</style>
    </li>
  );
}

export default SuggestionItem;



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionItem/index.js